module.exports = __webpack_public_path__ + "img/4.669b6978.jpg";